// Get Codes
export const GET_CODES_REQUEST = 'GET_CODES_REQUEST';
export const GET_CODES_DONE = 'GET_CODES_DONE';
export const GET_CODES_FAILED = 'GET_CODES_FAILED';
export const GET_CODES_RESET = 'GET_CODES_RESET';

// Operations
export const TOGGLE_CODE = 'TOGGLE_CODE';
export const TOGGLE_ALL_CODES = 'TOGGLE_ALL_CODES';
export const SET_CODES_FILTER = 'SET_CODES_FILTER';
export const SET_CODES_ALL_FILTERS = 'SET_CODES_ALL_FILTERS';
export const CLEAR_CODES_FILTERS = 'CLEAR_CODES_FILTERS';
export const CODES_SET_PAGE = 'CODES_SET_PAGE';